import React, { useState } from 'react';
import './SignUp.css';
import image1 from '../../assets/Hruthi AI EdTech White Transperant Background.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SignUp = ({ isOpen, onClose, setIsSignedUp }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setTimeout(() => {
      toast.success('Sign-up successful! 🎉'); 
      setIsSignedUp(true); 
      onClose(); 
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="signup-overlay">
        <div className="signup-modal">
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
          <div className="signup-container">
            <div className="signup-image">
              <img src={image1} alt="Logo" className="signup-logo" />
            </div>
            <div className="signup-content">
              <h2>Guaranteed Job Interviews with our Software Testing Course Until You Get Placed! Enquire Now</h2>
              <form className="signup-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                <button type="submit" className="signup-button">
                  Enquire Now
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
    </>
  );
};

export default SignUp;
